import React from 'react'
import { observer } from 'mobx-react'

import crosstab from '../assets/crosstab.svg'

const CrosstabSlidePreview = () => (
    <div style={{ backgroundColor: '#EFF4F6', height: '100%' }}>
        <div style={{ height: 10, backgroundColor: '#0B243A', position: 'relative' }}>
            <img src="https://cdn.explori.com/images/logo_explori.png" alt="explori logo" style={{ height: 5, position: 'absolute', right: 2, top: 2 }} />
        </div>

        <div style={{ display: 'flex', padding: 5, height: 'calc(100% - 10px)', gap: 2 }}>
            <div style={{ height: '100%', width: '100%', backgroundColor: 'white', padding: 5 }}>
                <img src={crosstab} style={{ height: '100%', width: '100%' }} />
            </div>
        </div>
    </div>
)

export default observer(CrosstabSlidePreview)
